import { Injectable } from "@angular/core";
import { AbstractClass, TableCell } from "@classes/abstract.class";
import { UserRol } from "@models/user-rol";

@Injectable({providedIn: 'root'})
export class UserRolClass extends AbstractClass {
  model: UserRol;
  modelName = 'UserRol';
  idName = 'userRoleID';
  langBase = 'cms.components.user-rol.';
  route = 'admin/es/settings/user-rol';
  tableCells: TableCell[] = [
    { name: 'roleName', label: 'rolName', cellType: 'text', order: true, download: true },
    { name: 'description', label: 'description', cellType: 'text', order: true, download: true },
    { name: 'isActive', label: 'isActive', cellType: 'boolean', order: true, download: true },
    { name: 'createdAt', label: 'createdAt', cellType: 'date', order: true, download: true },
    //{ name: 'siteLocation.city.countryZone.zoneName', label: 'countryZone', cellType: 'text', order: true },
    //{ name: 'siteLocation.city.cityName', label: 'city', cellType: 'text', order: true },
  ];
  formAccordion = [];
  formTabs = [];
  formCells = [
    // { name: 'name', label: 'name', cellType: 'text', disable: false, order: 1, cols: 'col-12 col-md-6', required: true, multiple: false },
    { name: 'roleName', label: 'rolName', cellType: 'text', disable: false, order: 1, cols: 'col-12 col-md-6', required: true, multiple: false, type: 'string' },
    { name: 'description', label: 'description', cellType: 'text', disable: false, order: 1, cols: 'col-12 col-md-6', required: true, multiple: false, type: 'string' },
    { name: 'isActive', label: 'isActive', cellType: 'checkbox', disable: false, order: 6, cols: 'col-12 col-md-6', required: false, multiple: false, type: 'boolean' }
  ];
  modelCells = [];
  tabs = [];

  constructor()
  {
    super();
    this.model = {
      userRoleID: 0,
      roleName: '',
      description: '',
      isActive: true,
      createdBy: '',
      createdAt: new Date(),
      updatedAt: new Date(),
      rol: null
    };
  }
}
